import React from "react";
import { useNavigate } from "react-router";

import { format, toCapitalize } from "Shared/Utils/shared";
import { WorkOrderRetrieve } from "Shared/Types/fleetmanagementapi";
import { UNITS, USERS, WORK_ORDERS_ADD } from "Shared/Constants/routes";

import commonStyles from "../WorkOrderStyles.module.scss";

export const useWorkOrderListHook = () => {
  const navigate = useNavigate();
  const goToWorkOrderAdd = () => {
    navigate(WORK_ORDERS_ADD);
  };
  const goToVehiclePage = (id: string) => {
    navigate(`${UNITS}/${id}`);
  };
  const goToUserPage = (id: string) => {
    navigate(`${USERS}/${id}`);
  };

  const renderCell = (
    cellData: any,
    columnId: string,
    workOrder: WorkOrderRetrieve
  ) => {
    if (columnId === "assigned_to") {
      return cellData ? (
        <span
          onClick={(e) => {
            e.stopPropagation();
            goToUserPage(workOrder.assigned_to.id);
          }}
          className={commonStyles.workOrder__cell_blue}
        >
          {`${workOrder.assigned_to?.first_name || ""} ${workOrder.assigned_to?.last_name || ""}`}
        </span>
      ) : (
        "---"
      );
    }
    if (columnId === "driver") {
      return cellData ? (
        <span
          onClick={(e) => {
            e.stopPropagation();
            goToUserPage(workOrder.driver.id);
          }}
          className={commonStyles.workOrder__cell_blue}
        >
          {`${workOrder.driver?.first_name || ""} ${workOrder.driver?.last_name || ""}`}
        </span>
      ) : (
        "---"
      );
    }

    if (columnId === "labels") {
      const labelsCount = cellData.length;
      return workOrder.labels.length ? (
        <span className={commonStyles.workOrder__cell_label}>
          {cellData[0]?.name} {labelsCount > 1 && `+${labelsCount - 1} more`}
        </span>
      ) : (
        <span>---</span>
      );
    }

    if (columnId === "issues") {
      const issuesCount = cellData.length;
      return (
        <p>
          {cellData[0]?.summary || "---"}
          {issuesCount > 1 && `+${issuesCount - 1} more`}{" "}
        </p>
      );
    }

    if (columnId === "status") {
      return (
        <p className={commonStyles.workOrder__cell}>
          <span className={commonStyles[`workOrder__cell_${cellData}`]}></span>
          {toCapitalize(cellData)}
        </p>
      );
    }

    if (columnId === "service_task_items") {
      const servicesCount = cellData.length;
      return servicesCount ? (
        <span>
          {cellData[0]?.service_task.name}
          {servicesCount > 1 && ` +${servicesCount - 1} more`}
        </span>
      ) : (
        "---"
      );
    }

    if (columnId === "vehicle") {
      return (
        <span
          className={commonStyles.workOrder__cell_blue}
          onClick={(e) => {
            e.stopPropagation();
            goToVehiclePage(workOrder.vehicle.id);
          }}
        >
          {workOrder?.vehicle?.name || "---"}
        </span>
      );
    }

    if (columnId === "vendor") {
      return <span>{workOrder?.vendor?.name || "---"}</span>;
    }
    if (columnId === "approved_by") {
      return <span>{workOrder?.approved_by?.first_name || "---"}</span>;
    }

    if (columnId === "issue_date") {
      return format(cellData, "YYYY-MM-DD");
    }

    return cellData || "---";
  };

  return { renderCell, goToWorkOrderAdd };
};
